<template>
  <v-tooltip
    v-bind="bindProps"
    :text="text"
  >
    <template #activator="{ props: activatorProps }">
      <!-- Mantém o wrapper leve; o activator precisa destes props -->
      <span v-bind="activatorProps">
        <slot />
      </span>
    </template>
  </v-tooltip>
</template>

<script setup>
import { useAttrs, computed } from 'vue'

defineOptions({ name: 'uiTooltip' })

const props = defineProps({
  text: { type: String, default: '', required: true }
})

const attrs = useAttrs()

// Compat: mapeia props antigas (top/bottom/left/right) para location do V3
const bindProps = computed(() => {
  const a = { ...attrs }
  const legacy = ['top', 'bottom', 'left', 'right']
  const pos = legacy.find(key => key in a && (a[key] === '' || a[key] === true))
  if (pos) {
    a.location = pos
    delete a[pos]
  }
  return a
})

const { text } = props
</script>

<style scoped>
/* sem estilos adicionais */
</style>
